export function setCookie(name, value, domainName, ttl) {
    let expires = '';

    if (domainName !== undefined) {
        domainName = `;domain=.${domainName}`;
    } else {
        domainName = '';
    }

    domainName = domainName || '';

    if (ttl) {
        const date = new Date();
        date.setTime(date.getTime() + (ttl * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }

    const cookie = `${name}=${value}${expires};path=/${domainName}`;

    document.cookie = cookie;
}

export function getCookie(name) {
    const nameEQ = name + "=";
    const nameValues = document.cookie.split(';');

    for (let i = 0; i < nameValues.length; i++) {
        const nameValue = nameValues[i].trim();

        if (nameValue.startsWith(nameEQ)) {
            return nameValue.substring(nameEQ.length, nameValue.length);
        }
    }

    return null;
}

export function deleteCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}



// WEBPACK FOOTER //
// ./js/cookie-utils/index.js